import { Component, Input, OnInit } from "@angular/core";
import { CustomModal } from "@modules/core/components/base-modals";
import { SumsubService } from "@modules/kyc/services/sumsub.service";
import { KYC_PROVIDER_SUMSUB, KYC_PROVIDER_SUMSUBVIDEO } from "@helpers/constants";
import { IdentityVerificationProvider } from "@modules/verification/modal/entities/identity-verification.model";

@Component({
	selector: "verification-redirect",
	templateUrl: "./identity-verification-redirect.component.html",
	styleUrls: ["./../success-screen.component.scss"],
	standalone: false
})
export class IdentityVerificationRedirectComponent extends CustomModal implements OnInit {
	@Input()
	public verificationApplication: IdentityVerificationProvider;
	public verificationLanguageId: string;

	public constructor(private sumsubService: SumsubService) {
		super();
	}

	public ngOnInit(): void {
		if (
			this.verificationApplication.name === KYC_PROVIDER_SUMSUB ||
			this.verificationApplication.name === KYC_PROVIDER_SUMSUBVIDEO
		) {
			this.sumsubService.init(this.verificationApplication.token, this.verificationLanguageId);
		}
	}

	public close(): void {
		this.modalService.pop();
	}
}
